import { register } from "@rill/loader";

/** Parse response JSON; returns null on empty body or parse error. */
async function safeParseJson(res) {
  const text = await res.text();
  if (!text?.trim()) return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

register(
  {
    name: "femaleCycleLogs",
    meta: ["no-bust", "female-cycle-logs"],
    ttl: "2 hours",
  },
  async ({ api }, { proxyAthlete }) => {
    const query = {
      proxyAthlete,
    };

    const res = await api("female-cycle-tracking", { query });

    const data = await safeParseJson(res);
    return data;
  }
);

register(
  {
    name: "femaleCycleSettings",
    meta: ["no-bust", "female-cycle-settings"],
    ttl: "2 hours",
  },
  async ({ api }, { proxyAthlete }) => {
    const query = {
      proxyAthlete,
    };

    const res = await api("female-cycle-settings", { query });

    const data = await safeParseJson(res);
    return data ?? null;
  }
);
